import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { ApplicationData } from "../../ls2pac/ApplicationData";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsCategory } from "../model/Category";

/**
 * formerly known as tlc.ls2kids.managers.categoryManager
 */
export class KidsCategoryManager {
	constructor() { }
	/**
	 * Get the categories and retain them.
	 */
	static fetchCategories() {
		TLCRest.jsonCall(LS2KIDS_CONSTANTS.restUrls.categories, {
			"type": TLCRest.types.POST,
			"postData": {
				"branchFilters": KidsCategoryManager._getBranchFilters(),
				"targetAudience": LS2KIDS_CONSTANTS.targetAudience
			},

			"callback": function (response) {
				TLCLogger.log('categories', response);

				KidsCategoryManager._categories = response;
				KidsCategoryManager._generateCategoryMap();
				TLCEventManager.fireEvent(
					LS2KIDS_CONSTANTS.Events.onGetCategoriesResponse,
					{
						success: true,
						data: response
					}
				);
			}
		});
	}
	/**
	 *
	 * @return {Array.<string>}
	 * @private
	 */
	static _getBranchFilters() {
		return ApplicationData.branchLimitsUtil.getLimitedBranches();
	}
	/**
	 *
	 * @return {Array.<KidsCategory>}
	 */
	static getCategories() {
		return KidsCategoryManager._categories.slice(0);
	}
	/**
	 * @return {KidsCategory}
	 */
	static getRandomCategory(obj) {
		if (!obj.items) {
			obj.items = [];
		}

		if (obj.items.length == 0) {
			obj.items = KidsCategoryManager._categories.slice(0);
		}

		var random = Math.floor(Math.random() * (obj.items.length - 1));
		var image = obj.items.splice(random, 1);

		return image[0];
	}
	static _generateCategoryMap() {
		var newMap = {};

		for (var i = 0, len = KidsCategoryManager._categories.length; i < len; i += 1) {
			var category = KidsCategoryManager._categories[i];
			newMap[category.id] = category;
		}

		KidsCategoryManager._categoryMap = newMap;
	}
	static getCategory(categoryId) {
		return KidsCategoryManager._categoryMap[categoryId];
	}
}
/**
 * @private
 * @type {Array.<KidsCategory>}
 */
KidsCategoryManager._categories = null;

/**
 * A list of categories when retrieving a random category and never getting a repeated one.
 * @type {Array.<KidsCategory>}
 * @private
 */
KidsCategoryManager._currentRotatedCategories = null;

/**
 * @private
 * @type {Object.<Number, KidsCategory>}
 */
KidsCategoryManager._categoryMap = null;

/**
 * @private
 * @type {jQuery.Promise}
 **/
KidsCategoryManager._deferredLoad = null;

KidsCategoryManager.getCategoriesEvent = LS2KIDS_CONSTANTS.Events.onGetCategories;

TLCEventManager.addListener(
	KidsCategoryManager.getCategoriesEvent,

	function() {
		KidsCategoryManager.fetchCategories();
	}
);






